import {
  formattedDuration,
  FormattedDurationOptions,
  MAX_MINUTES_TO_DISPLAY,
} from 'ui-format-utils';

type Props = {
  time: number;
  relativeTime: string;
  options?: FormattedDurationOptions;
};

export function WaitingTime({ time, relativeTime, options }: Props): React.ReactElement {
  return (
    <span data-time={time} data-estimate-start={relativeTime}>
      {time <= MAX_MINUTES_TO_DISPLAY * 60 ? formattedDuration(time, options) : relativeTime}
    </span>
  );
}
